import React, { useEffect, useRef, useState } from "react";
import "./Financials.css";
import Testimonial from "../../../Testimonial/Testimonial";
import { Helmet } from "react-helmet";

const Financials = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  return (
    <div>
      <Helmet>
        <title>Financial Technology Solutions | Our Tech Stack</title>
        <meta 
          name="description" 
          content="Explore our financial technology expertise and comprehensive tech stack including Angular, React, Node.js, Blockchain, AI and more for innovative financial solutions." 
        />
        <meta 
          name="keywords" 
          content="financial technology, fintech solutions, financial tech stack, Angular, React, Node.js, Blockchain, AI, financial software development, banking technology" 
        />
      </Helmet>
      
      <div className="findemo"></div>
      <Testimonial />

      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Financials;